import { setOrderConfigurationTestId } from "@bcc/components/order-configuration/order-configuration.utils";
import { setPrintingPreferencesViewTestId } from "@bcc/components/printing-preferences/printing-preferences-view.utils";
import { setProfilePreferencesTestId } from "@bcc/components/profile-preferences/profile-preferences.utils";
import { setPreferencesViewTestId } from "@bcc/components/views/preferences-view.utils";
import { ROUTE_PATHS } from "@bcc/lib/constants";
import { setSidebarNavTourId } from "../tour-ids";
import type { FeatureTour } from "../tour.types";
import { testIdSelector, tourTargetSelector } from "../tour.utils";

const printingPreferencesTestIds = setPrintingPreferencesViewTestId();
const PRINTING_PREFERENCES = testIdSelector(printingPreferencesTestIds.container);
const ORDER_CONFIGURATION = testIdSelector(setOrderConfigurationTestId("container"));

/** Inactive Radix tab content is unmounted, so tab steps click their trigger first (a no-op when already active) */
const openTab = (tab: string) => ({ clickTarget: testIdSelector(setPreferencesViewTestId(`${tab}-tab-trigger`)) });

export const preferencesTour: FeatureTour = {
  id: "preferences",
  titleKey: "tour.features.preferences.title",
  order: 6,
  requiredModule: "settings",
  requiredPage: "settings.view",
  steps: [
    {
      id: "preferences.overview",
      route: ROUTE_PATHS.PREFERENCES,
      target: tourTargetSelector(setSidebarNavTourId("settings")),
      titleKey: "tour.steps.preferences.overview.title",
      bodyKey: "tour.steps.preferences.overview.body",
      placement: "right",
    },
    {
      id: "preferences.mailing",
      route: ROUTE_PATHS.PREFERENCES,
      target: testIdSelector(setProfilePreferencesTestId("container")),
      titleKey: "tour.steps.preferences.mailing.title",
      bodyKey: "tour.steps.preferences.mailing.body",
      placement: "top",
      prepare: [openTab("mailing")],
    },
    {
      id: "preferences.printing",
      route: ROUTE_PATHS.PREFERENCES,
      // Vendors without label printing render a not-configured alert instead
      // of the container — anchor to whichever exists and adapt the text
      target: `${PRINTING_PREFERENCES}, ${testIdSelector(printingPreferencesTestIds.notAvailableAlert)}`,
      titleKey: "tour.steps.preferences.printing.title",
      bodyKey: "tour.steps.preferences.printing.body",
      placement: "top",
      prepare: [openTab("printing")],
      emptyState: {
        detectTarget: PRINTING_PREFERENCES,
        bodyKey: "tour.steps.preferences.printing.emptyBody",
      },
    },
    {
      id: "preferences.connections",
      route: ROUTE_PATHS.PREFERENCES,
      target: ORDER_CONFIGURATION,
      titleKey: "tour.steps.preferences.connections.title",
      bodyKey: "tour.steps.preferences.connections.body",
      placement: "top",
      prepare: [openTab("connections")],
      // The card swaps its form for an empty-state note when no storefront is connected
      emptyState: {
        detectTarget: `${ORDER_CONFIGURATION} form`,
        bodyKey: "tour.steps.preferences.connections.emptyBody",
      },
    },
  ],
};
